<template>
  <div style="height: calc(100vh - 85px);">
    <export-task ref="exportTask">
      <div slot="header">
        <search-bar v-model="formData" @search="handleSearch"></search-bar>
      </div>
    </export-task>
  </div>
</template>

<script>
import searchBar from './search'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  components: { searchBar },
  mixins: [pagePathMixin],
  data() {
    return {
      formData: {}
    }
  },
  methods: {
    searchChange(formData) {
      console.log('formData',formData)
      formData = this.$refs['exportTask'].setSearchForm(formData);
      this.$refs['exportTask'].init(formData)
    },
    handleSearch(data) {
      this.searchChange(data);
    }
  }
}
</script>
<style lang="stylus" scoped>
  >>> .el-header
    height auto !important
</style>
